export const FirebaseConfig = {
  apiKey: "AIzaSyD8rNNpS_hfmv94zL4x4Esp154SGIIIqPA",
  authDomain: "sports-safety-system.firebaseapp.com",
  databaseURL: "https://sports-safety-system.firebaseio.com",
  projectId: "sports-safety-system",
  storageBucket: "sports-safety-system.appspot.com",
  messagingSenderId: "133164951814",
  appId: "1:133164951814:web:d8d0f5dec9cd54d08bd687",
  measurementId: "G-16LJDJF0HK"
};